export const OrgRole = {
  ADMIN: 'ADMIN',
  OPS: 'OPS',
  SCHEMA_ADMIN: 'SCHEMA_ADMIN',
  MEMBER: 'MEMBER',
  SOURCE_ENGINEER: 'SOURCE_ENGINEER',
};

export const SystemRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  DEVELOPER: 'DEVELOPER',
};
